
// dp
import AIWritingIndex from '@/views/smartLife/AIWriting/index'

const dpRoutes = Array.from({ length: 24 }, (_, i) => ({
  path: `AIWriting/dp/index${i + 1}`,
  name: `AIWriting/dp/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIWriting/dp/index${i + 1}.vue`)
}))

// db
const dbRoutes = Array.from({ length: 23 }, (_, i) => ({
  path: `AIWriting/db/index${i + 1}`,
  name: `AIWriting/db/Index${i + 1}`,
  component: () => import(`@/views/smartLife/AIWriting/db/index${i + 1}.vue`)
}))

export default {
  path: '/smartLife',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'AIWriting/index',
      name: 'AIWritingIndex',
      component: AIWritingIndex
    },
    ...dpRoutes,

    ...dbRoutes

  ]
}
